<script setup lang="ts"></script>

<template>
  <aside class="flex h-full flex-col rounded-md bg-primary">
    <slot />
  </aside>
</template>

<style scoped></style>
